import { render, staticRenderFns } from "./TranslationDashboard.vue?vue&type=template&id=3ae44ee8&scoped=true&"
import script from "./TranslationDashboard.vue?vue&type=script&lang=js&"
export * from "./TranslationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TranslationDashboard.vue?vue&type=style&index=0&id=3ae44ee8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae44ee8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRadio,VRadioGroup,VRow})
